import React, { Fragment, ReactNode } from "react";
import { Helmet } from "react-helmet";
import { AppState } from "../../store";
import { SystemState } from "../../store/system/types";
import { connect } from "react-redux";

let href: string, content: string;
let allowedscripts: ReactNode[] = [];

switch (process.env.REACT_APP_CODE_TENANT) {
  case "SA":
    href = "/favicon/favicon_Salud.ico";
    content = "Salud";
    allowedscripts.push(<meta key={href} name="robots" content="noindex" />);
    break;
}

const HelmetIndex: React.FC<SystemState> = (props: SystemState) => {
  return (
    <Fragment>
      <Helmet>
        <title>{props.title}</title>
        <link rel="icon" href={href} type="image/x-icon" />
        <meta name="description" content={content} />
        {allowedscripts.map((item) => item)}
      </Helmet>
    </Fragment>
  );
};

const mapStateToProps = (state: AppState) => ({
  ...state.system,
});

export default connect(mapStateToProps)(HelmetIndex);
